enum API {
	GET_NOTIFICATIONS = '/api/notifications/main',
	NOTIFICATION_ACCESS = '/api/notifications',
	MARK_AS_READ = '/api/notifications/markAsRead'
}

export default API;
